














import { Component, Vue, Emit } from "vue-property-decorator";

import authService from "../services/AuthService";

@Component
export default class HeaderNavbar extends Vue {
  logout() {
    authService.logout().then((res: any) => {
      this.saveAuthenticated();
    });
  }

  @Emit("authenticated")
  saveAuthenticated() {
    this.$router.push("/login");
  }
}
